import loadable from '@loadable/component';

export const OrgDashboardRepostJobPageLoadable = loadable(
  () => import('./OrgDashboardRepostJobPage'),
  { resolveComponent: (module) => module.OrgDashboardRepostJobPage },
);
